import { Bold } from './Bold';
import { BulletList } from './BulletList';
import { Italic } from './Italic';
import { Link } from './Link';
import { OrderedList } from './OrderedList';
import { Strike } from './Strike';
import { Subscript } from './Subscript';
import { Superscript } from './Superscript';
import { Underline } from './Underline';
export const RichTextEditorIcons = {
    Bold,
    BulletList,
    Italic,
    Link,
    OrderedList,
    Strike,
    Subscript,
    Superscript,
    Underline,
};
export default RichTextEditorIcons;
